module.exports = __webpack_public_path__ + "static/media/camion_completo.75b255c2.svg";